export class ProductionJob {
  productionJobId: string;
  caseId:string;
  createdById:string;
  runById:string;
  title:string;
  comments:string;
  dateTimeCreated:string;
  dateTimeRun:string;
  batesBasePrefix:string;
  batesBaseNumberStart:number;
  batesBaseNumberDigits:number;
  customDesignation:string;
  isBatesStampPages:boolean;
  isControlNumberStampPages:boolean;
  isCreateTiff:boolean;
  docSizeProduced:number;
  docSizeWithheld:number;
  batesRangeProduction:string;
  isImportProductionJob:boolean;
  batesRangeWithheld:string;
  lifecycle:number;
  status:ProductionJobStatus;
  isIncludeNativeEmails:boolean;
  sortLevel1:number;
  sortLevel2:number;
  level1FieldId: string;
  processingStepCount?: number;
  totalDocCount?: number;
  lastModified: string;
  producedDocCount: number;
  withheldDocCount: number;
  partiallyPrivilegedDocCount: number;
  sortId: string;
}

export enum ProductionJobStatus {
  NeedValidation = 'NeedValidation',
  PreRun = 'PreRun',
  Queued = 'Queued',
  Running = 'Running',
  PostRun = 'PostRun'
}
